import { render, staticRenderFns } from "./modal-add-admin.vue?vue&type=template&id=4c3885a5&scoped=true&lang=pug"
import script from "./modal-add-admin.js?vue&type=script&lang=js&external"
export * from "./modal-add-admin.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-admin.vue?vue&type=style&index=0&id=4c3885a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3885a5",
  null
  
)

export default component.exports